import React, { useState } from 'react';
import TravelWarnings from '../components/TravelWarnings';
import TrendingTravelLocations from '../components/TrendingTravelLocations';
import '../styles/design-system.css';

export default function TravelInfoPage() {
  const [activeTab, setActiveTab] = useState('warnings');

  const tabs = [
    { id: 'warnings', name: 'Travel Warnings', icon: '🚨' },
    { id: 'trending', name: 'Trending Locations', icon: '🌍' },
    { id: 'unusual', name: 'Unusual Trips', icon: '🌟' }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm border-b border-gray-200">
        <div className="container py-8">
          <div className="text-center">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">Travel Information Center</h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Stay informed about travel warnings, discover trending destinations, and explore unique travel opportunities organized by our community.
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container py-8">
        {/* Tab Navigation */}
        <div className="flex flex-wrap justify-center gap-4 mb-8">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center gap-2 px-6 py-3 rounded-lg font-medium transition-colors ${
                activeTab === tab.id
                  ? 'bg-primary text-white shadow-md'
                  : 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-200'
              }`}
            >
              <span className="text-lg">{tab.icon}</span>
              <span>{tab.name}</span>
            </button>
          ))}
        </div>

        {/* Tab Content */}
        <div className="tab-content">
          {activeTab === 'warnings' && (
            <div>
              <div className="text-center mb-8">
                <h2 className="text-3xl font-bold text-gray-900 mb-4">Travel Warnings & Safety Info</h2>
                <p className="text-gray-600 max-w-2xl mx-auto">
                  Stay informed about current travel warnings, safety alerts, and important information for your destinations.
                </p>
              </div>
              <TravelWarnings />
            </div>
          )}

          {activeTab === 'trending' && (
            <div>
              <div className="text-center mb-8">
                <h2 className="text-3xl font-bold text-gray-900 mb-4">Trending Travel Locations</h2>
                <p className="text-gray-600 max-w-2xl mx-auto">
                  Discover the most popular destinations this season and get inspired for your next adventure.
                </p>
              </div>
              <TrendingTravelLocations />
            </div>
          )}

          {activeTab === 'unusual' && (
            <div>
              <div className="text-center mb-8">
                <h2 className="text-3xl font-bold text-gray-900 mb-4">Unusual & Offbeat Holidays</h2>
                <p className="text-gray-600 max-w-2xl mx-auto">
                  Explore unique travel experiences organized by our community members - from weekend trips to extraordinary adventures.
                </p>
              </div>
              <TrendingTravelLocations />
            </div>
          )}
        </div>

        {/* Additional Information */}
        <div className="mt-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="card p-6 text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white text-2xl">🛡️</span>
              </div>
              <h3 className="text-xl font-semibold mb-2">Safety First</h3>
              <p className="text-gray-600 text-sm">
                All travel information is regularly updated and verified. We prioritize your safety with comprehensive guidelines and emergency contacts.
              </p>
            </div>

            <div className="card p-6 text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white text-2xl">🤝</span>
              </div>
              <h3 className="text-xl font-semibold mb-2">Community Driven</h3>
              <p className="text-gray-600 text-sm">
                Many unique trips are organized by our verified community members, offering authentic experiences you won't find elsewhere.
              </p>
            </div>

            <div className="card p-6 text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white text-2xl">💬</span>
              </div>
              <h3 className="text-xl font-semibold mb-2">AI Travel Assistant</h3>
              <p className="text-gray-600 text-sm">
                Our friendly AI companion is here to help you with travel planning, safety tips, and personalized recommendations.
              </p>
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="mt-12 bg-gradient-to-r from-primary to-primary-dark text-white rounded-xl p-8 text-center">
          <h2 className="text-3xl font-bold mb-4">Ready to Start Your Journey?</h2>
          <p className="text-xl mb-6 opacity-90">
            Join our community of travelers and discover amazing destinations with compatible companions.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="btn btn-secondary text-lg px-8 py-4">
              Take Personality Test
            </button>
            <button className="btn btn-white text-lg px-8 py-4">
              Browse Travel Groups
            </button>
          </div>
        </div>
      </div>
    </div>
  );
} 